import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Button from 'react-bootstrap/lib/Button';
import Tooltip from 'react-bootstrap/lib/Tooltip'; 
import MenuItem from 'react-bootstrap/lib/MenuItem';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
/**
 * RunButton widget
 */
class RunButton extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.myRef = React.createRef();
  }

  render() {

    const items = [
      <MenuItem onSelect={(event)=>{
        this.setState({reImportThenRun: false});
        if (this.props.onSelectCallback) {
          this.props.onSelectCallback(false/*reImportThenRun*/);
        }
        this.props.onClickRun(event);
        document.body.click();
      }}>
        <span>{this.props.getMessage("dataframe.Run")}</span>
      </MenuItem>,
      <MenuItem onSelect={(event)=>{
        this.setState({reImportThenRun: true});
        if (this.props.onSelectCallback) {
          this.props.onSelectCallback(true/*reImportThenRun*/);
        }
        this.props.onReImportThenRun(event, true/*dataImport*/);
        document.body.click();
      }}>
        <span>{this.props.getMessage("dataframe.Run with Data Import")}</span>
      </MenuItem>,
    ];
    const overlay = (
      <Tooltip
        placement={"bottom"}
        className={"dataframe-menu-overlay dashboard data-source-refresh-menu" + (this.state.reImportThenRun ? " re-import-then-refresh" : "")}
      >
        <ul className="dropdown-menu open">{items}</ul>
      </Tooltip>
    );

    let refreshButtonLabel = this.props.getMessage("dataframe.Run");
    if (this.state.reImportThenRun) {
      refreshButtonLabel = this.props.getMessage("dataframe.Run with Data Import");
    }
    // If re-import is not enabled, show the Run button only
    if (!this.props.reImportEnabled) {
      return (
        <button 
          onClick={this.props.onClickRun}
          className="ia-param-submit-btn btn btn-primary">{this.props.getMessage("dataframe.Run")}
        </button>
      )
    } else if (this.props.onlyShowReImport) {
      return (
        <button 
          onClick={this.props.onReImportThenRun}
          className="ia-param-submit-btn btn btn-primary">{this.props.getMessage("dataframe.Run with Data Import")}
        </button>
      )
    }

    return (
      <ButtonToolbar className={"data-source-refresh-button-toolbar"}>
        <Button
          bsStyle={"link"}
          ref={"refresh"}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            document.body.click();
            if (this.state.reImportThenRun) {
              this.props.onReImportThenRun();
            } else {
              this.props.onClickRun();
            }
          }}
          className={"data-source-refresh all note"}
        >
          <div style={{"marginTop":"-1px"}}>
            <i className={"fal fa-play"}/>
            <span style={{"paddingLeft":"8px", fontSize: "13px"}}>{refreshButtonLabel}</span>
          </div>
        </Button>
        <OverlayTrigger
          container={window.document.body}
          placement={"bottom"}
          trigger="click"
          overlay={overlay}
          animation={false}
          ref="colmenuOverlay"
          rootClose
        >
        <Button onClick={(event)=>{
          event.preventDefault();
          event.stopPropagation();
          const runButton = document.querySelector('.data-source-refresh-button-toolbar.btn-toolbar');
          if (runButton && runButton.offsetWidth < 300) {
            setTimeout(()=>{
              const menu = document.querySelector('.dataframe-menu-overlay.data-source-refresh-menu.in.tooltip .tooltip-inner ul');
              if (menu) {
                menu.style.width = '265px';
                menu.style.left = '-275px';
              }
            });
          }
        }} className={"data-source-refresh-menu"}>
          <span>
            <i
              className={"fas fa-caret-down"}
            />
          </span>
        </Button>
        </OverlayTrigger>
      </ButtonToolbar>
    );
  }
}
export default RunButton;